/* global Blockly */
import React from 'react';
import { userIcon } from './index';

function defineBlock(context) {
    return {
        init: function () {
            this.setOpacity(0.6);
            this.appendDummyInput().appendField('      - deprecated -');
            this.setWarningText("This block was deprecated, please use the \"Get user field\" block instead.");

            this.appendDummyInput('WIDGET')
                .appendField('get')
                .appendField(new Blockly.FieldImage(userIcon, 30, 30, "user icon", null), 'userIcon')
                .appendField(new Blockly.FieldVariable(),'VARIABLE')
                .appendField('full name')
                .setOnNewRow(true);

            this.appendStatementInput('CALLBACK');

            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Get the full name of a logged in user.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + "#user");
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let variableName = Blockly.JavaScript.variableDB_.getName(block.getField('VARIABLE').getText(), Blockly.Variables.NAME_TYPE);
            let callback = Blockly.JavaScript.statementToCode(block, 'CALLBACK');
            return 'Snap.user.getFullName(function(' + variableName + ') {' + callback + '});\n';
        }
    }
}

const GetUserFullName = function (props) {
    const name = 'snap_user_get_full_name';
    GetUserFullName.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return <block type={name}></block>;
}

export default GetUserFullName;
